import Vue from 'vue'
import store from './store'
import App from './views/App'
import router from './routes'
import axios from './bootstrap'
import vuetify from './plugins/vuetify'
const ONE_MINUTE_IN_MS = 1000 * 60

require("regenerator-runtime/runtime")

import '../sass/app.scss'

Vue.use({
  install (Vue) {
    Vue.prototype.$axios = axios
  }
})

window.addEventListener('focus', () => {
  checkSession()
})

window.setInterval(() => {
  checkSession()
}, ONE_MINUTE_IN_MS)

function logout() {
  store.commit('setLoggedOut')
  if (router.currentRoute.name !== 'login') {
    router.replace({name: 'login'}).catch(() => {
    })
  }
}

function checkSession() {
  if (store.getters.sessionRefreshed + (ONE_MINUTE_IN_MS * 120) < Date.now()) {
    logout()
  }
}

async function bootstrapAuth() {
  const isPasswordResetRoute = window.location.pathname.startsWith('/password/reset')

  if (isPasswordResetRoute) {
    store.commit('setAuthChecked', true)
    store.commit('setLoggedOut')
    return
  }

  try {
    const response = await axios.get('/api/user')

    store.commit('setLoggedIn', response.data)
  } catch (e) {
    store.commit('setLoggedOut')
  }

  store.commit('setAuthChecked', true)
}

axios.interceptors.response.use(
  response => {
    store.commit('setSessionRefreshed', Date.now())
    return response
  },
  error => {
    switch (true) {
        // Unauthenticated or csrf token expired
      case [401, 419].includes(error?.response?.status):
        logout()
        break
      default:
        store.commit('setSnackbarColor', 'error')
        store.commit('setSnackbarMsg', error.response?.data?.message || 'Something went wrong')
        store.commit('setShowSnackbar', true)
    }
    return Promise.reject(error)
  }
)

Vue.component('App', require('./views/App.vue').default)

bootstrapAuth().then(() => {
new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
})
